import React, { useEffect } from "react";
import shopBanner from "../assets/shopViewBanner.png";
import './Shop.css';

function Shop({ shouldLoginOrShowCanvas, setShowLogin, isLoggedIn }) {
  // On load, open login if not already shown
  useEffect(() => {
      setShowLogin(shouldLoginOrShowCanvas());
  }, [shouldLoginOrShowCanvas, setShowLogin]);

  return (
      <div className="shop-view" style={{ display: isLoggedIn === false ? 'block' : 'none' }}>
          <img
              src={shopBanner}
              alt="Shop Banner"
              className="shop-banner"
          />
      </div>
  );
}

export default Shop;
